import { render, staticRenderFns } from "./NodeListNew.vue?vue&type=template&id=2b8b4f34&scoped=true"
import script from "./NodeListNew.vue?vue&type=script&lang=js"
export * from "./NodeListNew.vue?vue&type=script&lang=js"
import style0 from "./NodeListNew.vue?vue&type=style&index=0&id=2b8b4f34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b4f34",
  null
  
)

export default component.exports